import React from "react";
import { Typography, Container, Button } from "@mui/material";
import { Link } from "react-router-dom";
import InfiniteTable from "./InfiniteTable";

const columns = [
  { id: "pk", editable: "/entities", editablePk: "pk", label: "Entity ID" },
  { id: "name", editable: "/brands", editablePk: "pk", label: "Name" },
];

export const Setup = () => {
  return (
    <>
      <Container style={{ textAlign: "right" }}>
        <Link
          to="/entities/:id"
          style={{ textDecoration: "none" }}
          color="secondary"
        >
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Add Entity
            </Typography>
          </Button>
        </Link>
      </Container>
      <Container>
        <InfiniteTable
          apiep="data/api/entities/"
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Entity"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Setup;
